<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div class="row mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row mt-2">
                <div class="form-group mb-2 me-2 col-md-4 col-lg-4 col-xl-3">
                  <div class="col p-0">
                    <TraderMultiselect :multiple="true" v-model="tradersFilter">
                    </TraderMultiselect>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">{{ helper.trans('requisites.templates.title') }}</h5>
                <small class="text-muted">{{ helper.trans('requisites.templates.admin.readonly_hint') }}</small>
              </div>

              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('requisites.templates.admin.trader') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('requisites.templates.name') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.currency') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.payment_option') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('requisites.templates.field.method') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.req_group') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.device') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.min_pay_in_deal_sum') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.max_pay_in_deal_sum') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('requisites.templates.admin.created_at') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('requisites.templates.admin.updated_at') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="loaded && templates.items.length === 0">
                    <td colspan="13" class="text-center text-muted">{{ helper.trans('requisites.templates.empty') }}</td>
                  </tr>
                  <tr v-for="item in templates.items" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td>
                      <UserNameLabel v-if="tradersById[item.traderId]" :user="tradersById[item.traderId]"/>
                      <span v-else>#{{ item.traderId }}</span>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.currency ?? '-' }}</td>
                    <td>{{ item.paymentOption ? helper.trans('payment_options.' + item.paymentOption) : '-' }}</td>
                    <td>{{ item.method ? helper.trans('pay_methods.' + item.method) : '-' }}</td>
                    <td>{{ groupName(item.groupId) }}</td>
                    <td>{{ deviceName(item.deviceId) }}</td>
                    <td>{{ formatNumber(item.minPayInDealSum) }}</td>
                    <td>{{ formatNumber(item.maxPayInDealSum) }}</td>
                    <td>{{ dateHelper.format(item.createdAt) }}</td>
                    <td>{{ dateHelper.format(item.updatedAt) }}</td>
                    <td class="text-end">
                      <button type="button" @click="showTemplate(item)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first">
                        <i class="fa fa-eye me-1"></i>{{ helper.trans('requisites.templates.admin.view') }}
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <b-pagination
                v-if="templates.totalCount > templates.items.length"
                v-model="page"
                :total-rows="templates.totalCount"
                :per-page="templates.limit"
                :limit="20"
                @update:modelValue="load()"
                :prev-text="helper.trans('button.back')"
                :next-text="helper.trans('button.next')"
                align="start"
                first-number
                hide-goto-end-buttons
                hide-ellipsis
              ></b-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-modal dialog-class="modal-lg"
             :title="current ? `${helper.trans('requisites.templates.title')}: ${current.name}` : ''"
             :modelValue="current !== null"
             body-class="pt-0"
             @update:modelValue="onModalToggle"
    >
      <template #default>
        <table class="table table-striped border-light mt-3">
          <tbody>
          <tr v-for="row in detailRows" :key="row.label">
            <th class="text-capitalize-first w-50">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
          </tbody>
        </table>
      </template>
      <template #footer>
        <button type="button" @click="onModalToggle(false)" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.close') }}</button>
      </template>
    </b-modal>
  </LoaderWrapper>
</template>
<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {BModal, BPagination} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import UserNameLabel from "@/components/UserNameLabel.vue";
import APIClient from "@/service/APIClient";
import {helper} from "@/service/CommonHelper";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {Dictionary} from "@/types";
import TraderDTO from "@/models/TraderDTO";
import PaginationDTO from "@/models/PaginationDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import RequisiteTemplateDTO from "@/models/RequisiteTemplateDTO";
import TraderRequisiteGroupDTO from "@/models/TraderRequisiteGroupDTO";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";

const api = new APIClient();

interface DetailRow {
  label: string;
  value: string;
}

export default defineComponent({
  components: {
    LoaderWrapper,
    TraderMultiselect,
    UserNameLabel,
    BPagination,
    BModal,
  },
  setup() {
    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const state = reactive({
      tradersFilter: [] as TraderDTO[],
      page: 1,
      loaded: false,
      templates: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<RequisiteTemplateDTO>,
      tradersById: {} as Dictionary<TraderDTO>,
      groupsById: {} as Dictionary<TraderRequisiteGroupDTO>,
      devicesById: {} as Dictionary<TraderDeviceDTO>,
      current: null as RequisiteTemplateDTO | null,
    });

    const load = async () => {
      state.templates.offset = state.templates.limit * (state.page - 1)
      pageLoader.value?.show()
      try {
        state.templates = await api.requisiteTemplates(state.templates, {traderIds: state.tradersFilter.map((value) => value.id)})
        state.loaded = true

        const traderIds = [...new Set(state.templates.items.map((item) => item.traderId))]
        const deviceIds = [...new Set(state.templates.items.map((item) => item.deviceId).filter((id): id is string => !!id))]
        const tradersById = {} as Dictionary<TraderDTO>
        const groupsById = {} as Dictionary<TraderRequisiteGroupDTO>
        const devicesById = {} as Dictionary<TraderDeviceDTO>

        if (traderIds.length > 0) {
          for (const trader of (await api.traders({offset: 0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
            tradersById[trader.id.toString()] = trader
          }
          for (const group of (await api.traderRequisiteGroups({offset: 0, limit: 500} as PaginationDTO, {traderIds})).items) {
            groupsById[group.id.toString()] = group
          }
        }
        if (deviceIds.length > 0) {
          for (const device of (await api.traderDevices({offset: 0, limit: deviceIds.length} as PaginationDTO, {ids: deviceIds})).items) {
            devicesById[device.id.toString()] = device
          }
        }

        state.tradersById = tradersById
        state.groupsById = groupsById
        state.devicesById = devicesById
      } finally {
        pageLoader.value?.hide()
      }
    }

    const applyFilters = async () => {
      state.page = 1
      await load()
    }

    const clearFilters = async () => {
      state.tradersFilter = []
      state.page = 1
      await load()
    }

    const groupName = (id: number | null): string => {
      if (id === null) {
        return '-'
      }

      return state.groupsById[id.toString()]?.name ?? `#${id}`
    }

    const deviceName = (id: string | null): string => {
      if (id === null) {
        return '-'
      }

      return state.devicesById[id]?.name ?? `#${id.slice(0, 8)}`
    }

    const formatNumber = (value: number | null): string => {
      return value === null ? '-' : (numberFormatter.formatNumber(value) ?? '-')
    }

    const showTemplate = (template: RequisiteTemplateDTO) => {
      state.current = template
    }

    const onModalToggle = (visible: boolean) => {
      if (!visible) {
        state.current = null
      }
    }

    const detailRows = computed<DetailRow[]>(() => {
      const template = state.current
      if (template === null) {
        return []
      }

      const empty = helper.trans('requisites.templates.admin.empty_value')
      const text = (value: string | null) => value ?? empty
      const amount = (value: number | null) => value === null ? empty : (numberFormatter.formatNumber(value) ?? empty)
      const flag = (value: boolean | null) => value === true ? helper.trans('requisites.templates.admin.enabled') : empty
      const staticQr = (value: boolean | null, key: string) => value === true ? helper.trans(key) : empty

      return [
        {label: helper.trans('requisites.templates.admin.trader'), value: state.tradersById[template.traderId]?.name ?? `#${template.traderId}`},
        {label: helper.trans('requisites.templates.name'), value: template.name},
        {label: helper.trans('labels.currency'), value: text(template.currency)},
        {label: helper.trans('labels.payment_option'), value: template.paymentOption ? helper.trans('payment_options.' + template.paymentOption) : empty},
        {label: helper.trans('requisites.templates.field.method'), value: template.method ? helper.trans('pay_methods.' + template.method) : empty},
        {label: helper.trans('labels.payment_system'), value: template.paymentSystem ? helper.trans('payment_systems.' + template.paymentSystem) : empty},
        {label: helper.trans('labels.crossBorderCurrency'), value: text(template.crossBorderCurrency)},
        {label: helper.trans('labels.raw_field.swift'), value: text(template.swift)},
        {label: helper.trans('labels.req_group'), value: template.groupId === null ? empty : groupName(template.groupId)},
        {label: helper.trans('labels.device'), value: template.deviceId === null ? empty : deviceName(template.deviceId)},
        {label: helper.trans('requisites.active'), value: flag(template.isActive)},
        {label: helper.trans('labels.min_pay_in_deal_sum'), value: amount(template.minPayInDealSum)},
        {label: helper.trans('labels.max_pay_in_deal_sum'), value: amount(template.maxPayInDealSum)},
        {label: helper.trans('labels.multiples_of_value'), value: amount(template.multiplesOfValue)},
        {label: helper.trans('labels.daily_sum'), value: amount(template.dayTradesSumLimit)},
        {label: helper.trans('labels.monthly_sum'), value: amount(template.monthTradesSumLimit)},
        {label: helper.trans('labels.total_sum'), value: amount(template.totalTradesSumLimit)},
        {label: helper.trans('labels.daily_qty'), value: amount(template.dayTradesCountLimit)},
        {label: helper.trans('labels.monthly_qty'), value: amount(template.monthTradesCountLimit)},
        {label: helper.trans('labels.daily_qty_all_deals'), value: amount(template.dayTradesAllCountLimit)},
        {label: helper.trans('labels.monthly_qty_all_deals'), value: amount(template.monthTradesAllCountLimit)},
        {label: helper.trans('labels.total_qty'), value: amount(template.totalTradesCountLimit)},
        {label: helper.trans('labels.manual_reset_enabled'), value: flag(template.manualResetEnabled)},
        {label: helper.trans('labels.maxReuseCount'), value: amount(template.maxReuseCount)},
        {label: helper.trans('labels.reuseDaysCount'), value: amount(template.reuseDaysCount)},
        {label: helper.trans('labels.reusablePaymentsCountLimit'), value: amount(template.reusablePaymentsCountLimit)},
        {label: helper.trans('labels.onlyInternalTransfer'), value: flag(template.onlyInternalTransfer)},
        {label: helper.trans('labels.farmsSettings'), value: flag(template.isFarmsSettingsEnabled)},
        {label: helper.trans('labels.concurrent_trader_count'), value: amount(template.concurrentTradesCount)},
        {label: helper.trans('labels.trades_timeout_minutes'), value: amount(template.tradesTimeoutMinutes)},
        {label: `${helper.trans('labels.viet_qr_type')} (VIET_QR)`, value: staticQr(template.vietQrIsStatic, 'labels.viet_qr_static')},
        {label: `${helper.trans('labels.qris_type')} (IND_QR)`, value: staticQr(template.qrisIsStatic, 'labels.qris_static')},
        {label: `${helper.trans('labels.pix_type')} (BR_QR)`, value: staticQr(template.pixIsStatic, 'labels.pix_static')},
        {label: helper.trans('requisites.templates.admin.created_at'), value: dateHelper.format(template.createdAt)},
        {label: helper.trans('requisites.templates.admin.updated_at'), value: dateHelper.format(template.updatedAt)},
      ]
    })

    onMounted(() => {
      load()
    })

    return {
      ...toRefs(state),
      pageLoader,
      helper,
      dateHelper,
      load,
      applyFilters,
      clearFilters,
      groupName,
      deviceName,
      formatNumber,
      showTemplate,
      onModalToggle,
      detailRows,
    }
  }
})
</script>
